import { css } from "@emotion/css";
export const Div = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const backgroundColor = css`
  justify-content: center;
  display: flex;
  align-items: center;
`;

export const spotifyColor = css`
  background-color: #191414;
`;
/*export const videoStyle = css`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
`; */
